import React from "react";
import { Chart } from "react-google-charts";
import {IData} from "../../pages/PortfolioDashboard/types";


interface InputValues {
    data: any
    options: any
}




export function PieChart({data, options}: InputValues ) {
    return (
        <Chart
            chartType="PieChart"
            data={data}
            options={options}
            width={"100%"}
            height={"400px"}
        />
    );
}
